// extracted by mini-css-extract-plugin
export default {"form_heading":"social_form_heading__qL0-x","form_headingStrongUpper":"social_form_headingStrongUpper__RD9dk","submit_button":"social_submit_button__GxwmC"};